import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

const appConfigRouter = {
  path: '/app_config',
  component: Management,
  redirect: '/app_config/index/login',
  children: [
    {
      path: 'index',
      component: () => import('@/views/app_configs/Index'),
      redirect: 'index/login',
      meta: {
        auth: Auth.common
      },
      children: [
        {
          path: 'login',
          component: () => import('@/views/app_configs/Login'),
          meta: {
            auth: Auth.common,
            tabName: 'login'
          }
        },
        {
          path: 'push',
          component: () => import('@/views/app_configs/Push'),
          meta: {
            auth: Auth.common,
            tabName: 'push'
          }
        },
        {
          path: 'pay',
          component: () => import('@/views/app_configs/Pay'),
          meta: {
            auth: Auth.common,
            tabName: 'pay'
          }
        },
        {
          path: 'email',
          component: () => import('@/views/app_configs/Email'),
          meta: {
            auth: Auth.common,
            tabName: 'email'
          }
        },
        {
          path: 'sms',
          component: () => import('@/views/app_configs/Sms'),
          meta: {
            auth: Auth.common,
            tabName: 'sms'
          }
        }
      ]
    }
  ]
}

export default appConfigRouter
